/*
 * File: story.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on May 16, 2025 at 12:33 AM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 16, 2025 at 12:37 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Utilities
 */

export const formatStoryText = (content) => {
	if (!content) return '';
	return content.replace(/(<br>)+/g, '<br>').replace(/\n\s*\n/g, '\n').replace(/\n+/g, '\n\n').replace(/<br\s*\/?>/gi, '\n\n');
};
